"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenCageDataProvider = void 0;
const opencage = require("opencage-api-client");
const distance_1 = require("@turf/distance");
const GeocodingProvider_1 = require("./GeocodingProvider");
class OpenCageDataProvider extends GeocodingProvider_1.default {
    constructor(apiKey, settings) {
        super("opencage");
        this.requestId = 1;
        this.apiKey = apiKey;
        this.settings = settings !== null && settings !== void 0 ? settings : { maxResults: 10 };
    }
    forward(query, callback) {
        const opencageQuery = { q: query.string, key: this.apiKey };
        if (query.location) {
            opencageQuery.bounds = `${query.location.lon - 2},${query.location.lat - 1},${query.location.lon + 2},${query.location.lat + 1}`;
        }
        if (typeof this.settings.bounds !== "undefined") {
            const bounds = this.settings.bounds;
            opencageQuery.bounds = `${bounds[0]},${bounds[1]},${bounds[2]},${bounds[3]}`;
        }
        if (typeof query.bounds !== "undefined") {
            const bounds = query.bounds;
            opencageQuery.bounds = `${bounds[0]},${bounds[1]},${bounds[2]},${bounds[3]}`;
        }
        if (typeof this.settings.countrycode !== "undefined") {
            opencageQuery.countrycode = this.settings.countrycode;
        }
        if (this.settings.language) {
            opencageQuery.language = this.settings.language;
        }
        if (this.settings.proximity) {
            // uses 'lat,lon'
            opencageQuery.proximity = this.settings.proximity.lat + "," + this.settings.proximity.lng;
        }
        if (typeof opencageQuery.language === "undefined") {
            opencageQuery.language = this.settings.locale;
        }
        this.requestId++;
        const requestId = this.requestId;
        if (query.string.length < 2) {
            callback([]);
            return;
        }
        opencage
            .geocode(opencageQuery)
            .then((data) => {
            if (this.requestId != requestId) {
                return;
            }
            const results = [];
            data.results.forEach(r => {
                const result = {
                    description: r.formatted,
                    location: r.geometry,
                    provider: this.name,
                    score: 20,
                    type: r.components._type
                };
                // filter out irrelevant results.
                if (result.type == "parking" ||
                    result.type == "fast_food")
                    return;
                // calculate our own confidence levels.
                if (result.type == "city") {
                    result.score = 95;
                    // TODO: when far away, reduce score.
                }
                else if (result.type == "village") {
                    result.score = 95;
                    result.description = r.components.village;
                    // TODO: when far away, reduce score.
                }
                else if (result.type == "road") {
                    return;
                }
                else if (result.type == "railway") {
                    result.score = 96;
                    result.description = r.components.railway;
                }
                // replace results with the same description if score is better.
                const i = results.findIndex(x => x.description == result.description);
                if (i >= 0) {
                    const existing = results[i];
                    if (existing.score < result.score) {
                        results[i] = result;
                    }
                }
                else {
                    results.push(result);
                }
            });
            callback(results);
        })
            .catch((error) => {
            console.error(error);
        });
    }
    reverse(l, callback) {
        if (!l)
            return callback([]);
        opencage
            .geocode({ q: `${l.lat},${l.lng}`, key: this.apiKey })
            .then((data) => {
            return callback([{
                    description: data.results[0].formatted,
                    location: data.results[0].geometry,
                    distance: distance_1.default([l.lng, l.lat], [data.results[0].geometry.lng, data.results[0].geometry.lat]) * 1000
                }]);
        })
            .catch((error) => {
            console.error(error);
        });
    }
}
exports.OpenCageDataProvider = OpenCageDataProvider;
